import { EPaymentChannel } from 'enums';

export interface IPaymentProviderItem {
  name: string;
  channel: EPaymentChannel;
}

export const PAYMENT_PROVIDERS: IPaymentProviderItem[] = [
  // ── MFS ──
  { name: 'bKash', channel: EPaymentChannel.MFS },
  { name: 'Nagad', channel: EPaymentChannel.MFS },
  { name: 'Rocket', channel: EPaymentChannel.MFS },
  { name: 'Upay', channel: EPaymentChannel.MFS },
  { name: 'mCash', channel: EPaymentChannel.MFS },
  { name: 'Tap', channel: EPaymentChannel.MFS },
  { name: 'SureCash', channel: EPaymentChannel.MFS },
  { name: 'OK Wallet', channel: EPaymentChannel.MFS },

  // ── Bank ──
  { name: 'BRAC Bank', channel: EPaymentChannel.Bank },
  { name: 'Dutch-Bangla Bank (DBBL)', channel: EPaymentChannel.Bank },
  { name: 'City Bank', channel: EPaymentChannel.Bank },
  { name: 'Eastern Bank (EBL)', channel: EPaymentChannel.Bank },
  { name: 'Islami Bank Bangladesh', channel: EPaymentChannel.Bank },
  { name: 'Prime Bank', channel: EPaymentChannel.Bank },
  { name: 'Pubali Bank', channel: EPaymentChannel.Bank },
  { name: 'United Commercial Bank (UCB)', channel: EPaymentChannel.Bank },
  { name: 'Mutual Trust Bank (MTB)', channel: EPaymentChannel.Bank },
  { name: 'Bank Asia', channel: EPaymentChannel.Bank },
  { name: 'Southeast Bank', channel: EPaymentChannel.Bank },
  { name: 'Trust Bank', channel: EPaymentChannel.Bank },
  { name: 'Jamuna Bank', channel: EPaymentChannel.Bank },
  { name: 'Dhaka Bank', channel: EPaymentChannel.Bank },
  { name: 'Mercantile Bank', channel: EPaymentChannel.Bank },
  { name: 'NCC Bank', channel: EPaymentChannel.Bank },
  { name: 'One Bank', channel: EPaymentChannel.Bank },
  { name: 'Premier Bank', channel: EPaymentChannel.Bank },
  { name: 'IFIC Bank', channel: EPaymentChannel.Bank },
  { name: 'AB Bank', channel: EPaymentChannel.Bank },
  { name: 'Shahjalal Islami Bank', channel: EPaymentChannel.Bank },
  { name: 'Al-Arafah Islami Bank', channel: EPaymentChannel.Bank },
  { name: 'EXIM Bank', channel: EPaymentChannel.Bank },
  { name: 'Social Islami Bank (SIBL)', channel: EPaymentChannel.Bank },
  { name: 'Standard Chartered', channel: EPaymentChannel.Bank },
  { name: 'HSBC', channel: EPaymentChannel.Bank },
  { name: 'Sonali Bank', channel: EPaymentChannel.Bank },
  { name: 'Janata Bank', channel: EPaymentChannel.Bank },
  { name: 'Agrani Bank', channel: EPaymentChannel.Bank },
  { name: 'Rupali Bank', channel: EPaymentChannel.Bank },

  // ── Card & Cash ──
  { name: 'Card', channel: EPaymentChannel.Card },
  { name: 'Cash', channel: EPaymentChannel.Cash },
];
